import { SummaryMatchModel } from '@clsplus/cls-plus-data-models'
import type { SnapshotIn } from 'mobx-state-tree'
import { destroy, getSnapshot, types } from 'mobx-state-tree'

const MatchesSearchMap = types.model('MatchesSearchMap', {
  filter: types.identifier,
  data: types.array(SummaryMatchModel),
  unavailableMatchIds: types.array(types.string),
})

export const createMatchesSearchMap = (filter: string, response: unknown) => {
  if (!Array.isArray(response)) throw new Error('Unexpected match-list response')

  const data: SnapshotIn<typeof SummaryMatchModel>[] = []
  const unavailableMatchIds: string[] = []
  response.forEach((snapshot, index) => {
    try {
      // Explicit validation also runs in production, where implicit MST checks can be disabled.
      if (!SummaryMatchModel.is(snapshot)) throw new Error('Incompatible match snapshot')
      const match = SummaryMatchModel.create(snapshot)
      data.push(getSnapshot(match))
      destroy(match)
    } catch {
      const id = snapshot && typeof snapshot.id === 'string' ? snapshot.id : `record ${index + 1}`
      unavailableMatchIds.push(id)
    }
  })

  return MatchesSearchMap.create({ filter, data, unavailableMatchIds })
}

export default MatchesSearchMap
